(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("menuService", ["authService", "frameworkService", "$http", "$filter", "_", menuService]);
    function menuService(authService, frameworkService, $http, $filter, _) {
        var menuServiceFactory = {};
        function getMenu() {
            var enabledFeatures = _.map(_.filter(_.pairs(frameworkService.data.tenantFeatures), function (feature) { return feature[1]; }), _.first);
            return $http.get("app/admin/menu.json", {}).then(function (response) {
                return sortMenu($filter("filter")(response.data, filterMenu));
                function filterMenu(item) {
                    var roles;
                    var features;
                    var anyFeatures;
                    if (item.subMenus !== undefined && item.subMenus.length > 0) {
                        roles = _.uniq(_.flatten(_.map(_.pluck(item.subMenus, "roles"), filterByFeature)));
                        features = _.uniq(_.flatten(_.pluck(item.subMenus, "features")));
                        anyFeatures = _.uniq(_.flatten(_.pluck(item.subMenus, "anyFeatures")));
                    }
                    else {
                        roles = filterByFeature(item.roles);
                        features = item.features;
                        anyFeatures = item.anyFeatures;
                    }
                    if (compareArrays(roles, authService.authentication.roles)) {
                        if (item.subMenus !== undefined && item.subMenus.length > 0)
                            item.subMenus = $filter("filter")(item.subMenus, filterMenu);
                        if (item.subMenus && item.subMenus.length !== 0) {
                            //root menu should be shown at least one of its feature is enabled
                            if ((!features && !anyFeatures) || (_.includes(features, undefined) && _.includes(anyFeatures, undefined)) || (features && compareArrays(features, enabledFeatures)))
                                return item;
                            else if (anyFeatures && compareArrays(anyFeatures, enabledFeatures))
                                return item;
                        }
                        else {
                            //child menu should be shown if all of its features are enabled
                            if ((!features && !anyFeatures) || (_.includes(features, undefined) && _.includes(anyFeatures, undefined)) || (features && _.difference(features, enabledFeatures).length === 0))
                                return item;
                            else if (anyFeatures && compareArrays(anyFeatures, enabledFeatures))
                                return item;
                        }
                    }
                    return null;
                }
                function compareArrays(actual, expected) {
                    return _.intersection(actual, expected).length > 0 || actual.indexOf("*") >= 0;
                }
                function sortMenu(menu) {
                    _.each(menu, function (item) {
                        if (item.subMenus !== undefined && item.subMenus.length > 0)
                            item.subMenus = sortMenu(item.subMenus);
                    });
                    return _.sortBy(menu, "order");
                }
                function filterByFeature(obj) {
                    if (_.isArray(obj))
                        return obj;
                    else {
                        var rolesArray = [];
                        for (var index in obj) {
                            if (obj.hasOwnProperty(index)) {
                                if (index === "default")
                                    continue;
                                if (_.includes(enabledFeatures, index)) {
                                    if (rolesArray.length === 0)
                                        rolesArray = obj[index];
                                    else
                                        rolesArray = _.intersection(rolesArray, obj[index]);
                                }
                            }
                        }
                        if (rolesArray.length === 0)
                            rolesArray = obj.default;
                        return rolesArray;
                    }
                }
            });
        }
        menuServiceFactory.getMenu = getMenu;
        return menuServiceFactory;
    }
})();
